import { IBaseOrderEntity } from '@easy-lib/modules/order';
import { Update } from '@ngrx/entity';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const BaseOrderAction = {
	load: emptyProps(),
	loading: emptyProps(),
	loaded: emptyProps(),
	loadedError: emptyProps(),
	empty: emptyProps(),
	set: props<{ values: IBaseOrderEntity[] }>(),
	add: props<{ value: IBaseOrderEntity }>(),
	addMany: props<{ values: IBaseOrderEntity[] }>(),
	delete: props<{ id: string | number }>(),
	deleteMany: props<{ ids: string[] }>(),
	update: props<Update<IBaseOrderEntity>>(),
	updateMany: props<{ values: Update<IBaseOrderEntity>[] }>()
};

export const OrderAction = createActionGroup({
	source: 'order',
	events: {
		...BaseOrderAction
	}
});
